import {
  AUTHENTICATED,
  AUTHENTICATED_FAILED,
  HIDE_AUTH_MESSAGE,
  SHOW_AUTH_MESSAGE,
  SHOW_LOADING,
  SIGNOUT,
  SIGNUP_SUCCESS,
  REFRESH_TOKEN,
  REFRESH_TOKEN_FAILURE,
  REFRESH_TOKEN_SUCCESS,
  REFRESH_TOKEN_DISPATCHED,
} from "../constants/Auth";

const initState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: "",
  refreshToken: "",
  email: "",
  fullName: "",
  firstName: "",
  lastName: "",
  userName: "",
  isPaid: false,
  subscripitionExpiryDate: "",
  phoneNumber: "",
  permissions: {},
  agencyName: "",
  id: "",
  roles: {},
  refreshTokenDispatched: false,
};

const auth = (state = initState, action) => {
  switch (action.type) {
    case AUTHENTICATED:
      return {
        ...state,
        loading: false,
        redirect: "/",
        token: action.accessToken,
        refreshToken: action.refreshToken,
        permissions: action.permissions,
        roles: action.roles,
        message: action.message,
        fullName: action.fullName,
        firstName: action.firstName,
        lastName: action.lastName,
        userName: action.userName,
        isPaid: action.isPaid,
        subscripitionExpiryDate: action.subscripitionExpiryDate,
        phoneNumber: action.phoneNumber,
        email: action.email,
        agencyName: action.agencyName,
        id: action.id,
        refreshTokenDispatched: false,
        showMessage:
          action.message !== null &&
          action.message !== undefined &&
          action.message !== ""
            ? true
            : false,
      };
    case AUTHENTICATED_FAILED: {
      return {
        ...state,
        token: null,
        loading: false,
      };
    }
    case REFRESH_TOKEN_DISPATCHED: {
      return {
        ...state,
        refreshTokenDispatched: true,
      };
    }
    case SHOW_AUTH_MESSAGE:
      return {
        ...state,
        message: action.message,
        showMessage: true,
        loading: false,
      };
    case HIDE_AUTH_MESSAGE:
      return {
        ...state,
        message: "",
        showMessage: false,
      };
    case SIGNOUT: {
      return {
        ...state,
        redirect: "/",
        token: null,
        permissions: null,
        loading: false,
      };
    }
    case SIGNUP_SUCCESS: {
      return {
        ...state,
        loading: false,
        token: action.token,
      };
    }
    case SHOW_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case REFRESH_TOKEN:
      return {
        ...state,
        loading: true,
      };
    case REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        token: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        error: null,
      };
    case REFRESH_TOKEN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default auth;
